import { render, staticRenderFns } from "./BasicAlert.vue?vue&type=template&id=a8188ee4&scoped=true"
import script from "./BasicAlert.vue?vue&type=script&lang=js"
export * from "./BasicAlert.vue?vue&type=script&lang=js"
import style0 from "./BasicAlert.vue?vue&type=style&index=0&id=a8188ee4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8188ee4",
  null
  
)

export default component.exports